/* Suvorya: visit and action logger (client side).
   Sends small beacons to the Vercel function api/visit.js, which adds
   IP/location/time and writes a row to a private Google Sheet.

   Logged: page_view, add_to_cart, buy_now, wishlist_add, checkout_click.
   It only runs for visitors who accepted analytics cookies in Shopify's consent
   banner. To keep your own visits out of the log, open any page once with
   ?sv_nolog=1 (undo with ?sv_nolog=0). */
(function () {
  var script = document.currentScript;
  var endpoint = script && script.getAttribute('data-endpoint');
  if (!endpoint) return;

  try {
    var q = /[?&]sv_nolog=([01])/.exec(location.search);
    if (q) localStorage.setItem('sv_nolog', q[1]);
    if (localStorage.getItem('sv_nolog') === '1') return;
  } catch (e) {}

  var pageSent = false;

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function post(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      } else {
        fetch(endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
      }
    } catch (e) {}
  }

  function pagePath() {
    return location.pathname + location.search.replace(/[?&]sv_nolog=[01]/, '');
  }

  function sendPageView() {
    if (pageSent || !allowed()) return;
    pageSent = true;
    post({ p: pagePath(), r: document.referrer ? document.referrer.slice(0, 300) : '', e: 'page_view' });
  }

  /* Log an action. Silently does nothing unless the visitor accepted analytics. */
  window.svTrack = function (event, detail) {
    if (!allowed()) return;
    post({ p: pagePath(), r: '', e: String(event || '').slice(0, 40), d: String(detail || '').slice(0, 200) });
  };

  function productHandle() {
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function start() {
    sendPageView();
    document.addEventListener('visitorConsentCollected', sendPageView);

    // Add to bag (the product page form posts to /cart/add)
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      if (/\/cart\/add/.test(f.getAttribute('action') || '')) {
        var qty = f.querySelector('[name="quantity"]');
        var variant = f.querySelector('[name="id"]');
        window.svTrack('add_to_cart', productHandle() + ' x' + (qty && qty.value ? qty.value : 1) + (variant && variant.value ? ' (variant ' + variant.value + ')' : ''));
      }
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;

      // Buy now button on the product page
      var buy = t.closest('[data-sv-buynow]');
      if (buy) { window.svTrack('buy_now', productHandle()); return; }

      // Wishlist heart: log only when the item was just added
      var heart = t.closest('[data-sv-wishlist-toggle]');
      if (heart) {
        var handle = heart.getAttribute('data-product-handle') || '';
        setTimeout(function () {
          if (heart.classList.contains('is-active')) window.svTrack('wishlist_add', handle);
        }, 50);
        return;
      }

      // Checkout button / link in the bag
      var link = t.closest('a[href*="/checkout"], [name="checkout"]');
      if (link) window.svTrack('checkout_click', 'bag');
    }, true);
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) start();
    });
  }
})();
